import axios from "axios";
import { Currency } from "../models/Currency.js";

import getErrorDetails from "./helpers/getErrorDetails.js";

export async function getCurrencies(
  options: any
): Promise<{ currencies: Currency[]; totalItems: number }> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/currencies`,
    });

    const { data = [] } = response;

    return {
      currencies: data,
      totalItems: data.length,
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
}
